export const localDate = (inputDate?: Date) => {
  return inputDate ? new Date(inputDate) : new Date();
};
